export enum IntegrationsRoutes {
  root = 'integrations',
  main = '',
  providers = 'providers',
}
